import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";

import { matchAllText } from "../utils";

const FormSuggestBox = ({
  formik,
  controlId,
  label,
  required,
  options,
  labelMap = lv => (lv && lv.label) || "",
  ...props
}) => {
  const [showSuggest, setShowSuggest] = useState(false);
  const [filtered, setFiltered] = useState([...options]);
  const inputRef = useRef(null);

  useEffect(
    () => {
      const value = formik.values[controlId];
      setFiltered(
        options.filter(o => {
          return matchAllText(o.value, value);
        })
      );
    },
    [formik.values, options, controlId]
  );

  const handleChange = e => {
    formik.handleChange(e);
  };

  const handleItemClicked = item => {
    formik.handleChange({ target: { name: controlId, value: item.value } });
    inputRef.current.focus();
    setShowSuggest(false);
  };

  const handleBlur = e => {
    setTimeout(() => setShowSuggest(false), 200);
    formik.handleBlur(e);
  };

  return (
    <Form.Group controlId={controlId} {...props}>
      <Form.Label>
        {label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>

      <Form.Control
        ref={inputRef}
        name={controlId}
        value={formik.values[controlId]}
        onChange={handleChange}
        onFocus={() => setShowSuggest(true)}
        onBlur={handleBlur}
        disabled={formik.isSubmitting}
        isInvalid={formik.touched[controlId] && !!formik.errors[controlId]}
        autoComplete="off"
      />
      {showSuggest && filtered.length > 0 && (
        <div className="suggest-container">
          <div className="suggest-inner">
            <div className="suggest-items">
              {filtered.slice(0, 6).map((o, i) => (
                <div
                  className="suggest-item"
                  key={i}
                  onClick={() => handleItemClicked(o)}
                >
                  {labelMap(o)}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <Form.Control.Feedback type="invalid">
        {formik.errors[controlId]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default FormSuggestBox;
